export const LOCAL_STORAGE_KEYS = {
  logoutCount: "logoutCount",
};
